/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useIsPhone} from '@ion/dls/src/hooks/useMedia';
import {
  assetDetailViewSelector,
  findNearbySelector,
  selectedAssetSelector,
  selectedToolSelector
} from '@/store/selectors/tracking-selectors';

/**
 * @useShowCrumbs
 * React Hook to show or hide crubs
 * 
 *  ```typescript
 *   import {useShowCrumbs} from '@/routes/tracking/hooks';
 * 
 *   const [showCrumbs] = useShowCrumbs();
 *  ```
 */
export const useShowCrumbs = () => {
  const [showCrumbs, setShowCrumbs] = useState<boolean>(false);
  const isPhone             = useIsPhone();
  const selectedAsset       = useSelector(selectedAssetSelector);
  const assetDetailView     = useSelector(assetDetailViewSelector);
  const selectedTool        = useSelector(selectedToolSelector);
  const findLabel           = useSelector(findNearbySelector);
  
  useEffect(() => {
    const show = Boolean((selectedAsset && assetDetailView) || selectedTool || (findLabel.isActive && isPhone));
    setShowCrumbs(show);
  }, [selectedAsset, assetDetailView, selectedTool, findLabel, isPhone]);
  return [showCrumbs];
};
